var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9131 12.4V13.5C11.9131 15.7091 10.1222 17.5 7.91308 17.5H4.99996C2.79083 17.5 0.999965 15.7091 0.999965 13.5V4.5C0.999965 2.29086 2.79083 0.5 4.99997 0.5H7.91309C10.1222 0.5 11.9131 2.29086 11.9131 4.5V5.59999",
    stroke: "#CD9D41",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4313 11.5498L16.2557 9.7025C16.6404 9.31301 16.6404 8.68662 16.2557 8.29712L14.4313 6.44982",
    stroke: "#CD9D41",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1103 8.99975L6.03662 8.99976",
    stroke: "#CD9D41",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.b3375630e476ab7e4c99488e9b3a1f6d.svg";
export { ForwardRef as ReactComponent };